/** Whitelisted aspect-ratio tokens that have matching CSS in index.css. */
const ASPECT_TOKENS = new Set(["16x9", "4x3", "3x4", "1x1"]);

/**
 * Map a space-separated size directive (e.g. "full 16x9") to whitelisted
 * sizing class names. Shared by the markdown image renderer and the `:::media`
 * container directive so both speak the same vocabulary.
 *   "full"      -> ["lastbot-media-full"]
 *   "full 16x9" -> ["lastbot-media-full", "lastbot-aspect-16x9"]
 * Unknown tokens are ignored.
 */
export const sizeClasses = (size: string | null | undefined): string[] => {
  const tokens = (size ?? "").split(/\s+/).filter(Boolean);
  const classes: string[] = [];
  if (tokens.includes("full")) classes.push("lastbot-media-full");
  const aspect = tokens.find((t) => ASPECT_TOKENS.has(t));
  if (aspect) classes.push(`lastbot-aspect-${aspect}`);
  return classes;
};
